import { useAuthContext } from '@/contexts/auth-context';

/**
 * `is_first_job_post_on_account` for the posting events. Undefined when
 * whoami predates `account_has_sourcing_purchases`, so the property is left
 * off rather than sent as a guess.
 */
export function useIsFirstJobPostOnAccount(): boolean | undefined {
  const { whoami } = useAuthContext();
  const hasSourcingPurchases = whoami?.account_has_sourcing_purchases;
  return typeof hasSourcingPurchases === 'boolean'
    ? !hasSourcingPurchases
    : undefined;
}
